const time = (value) => value === null ? 0 : new Date(value).getTime();
/** Building, planned, open (by votes, ties newest), then done, not now. */
const RANK = {
    building: 0,
    planned: 1,
    open: 2,
    done: 3,
    not_now: 4,
};
export function compareIdeas(a, b) {
    if (a.status !== b.status)
        return RANK[a.status] - RANK[b.status];
    if (a.status === 'done') {
        return (time(b.doneAt ?? b.createdAt) - time(a.doneAt ?? a.createdAt) ||
            time(b.createdAt) - time(a.createdAt));
    }
    if (a.status === 'not_now')
        return time(b.createdAt) - time(a.createdAt);
    return b.votesCount - a.votesCount || time(b.createdAt) - time(a.createdAt);
}
export function orderIdeas(ideas) {
    return [...ideas].sort(compareIdeas);
}
/** The board's sections: the live list, and the two folded ones (D199). */
export function groupIdeas(ideas) {
    const ordered = orderIdeas(ideas);
    return {
        active: ordered.filter((idea) => idea.status !== 'done' && idea.status !== 'not_now'),
        done: ordered.filter((idea) => idea.status === 'done'),
        notNow: ordered.filter((idea) => idea.status === 'not_now'),
    };
}
//# sourceMappingURL=ideas.js.map